export default __webpack_public_path__ + "static/media/earnbigicon.f2be1e9c.svg";